export default function () {
  const widgetName = 'circleCardsSimple';
  const widgetOpts = circleCardsSimpleOpts;

  const breakpoint = 800;
  const isDesktopScreen = $(window).width() >= breakpoint;
  const wrapContainerClass = 'cards-simple-container-wrapper';
  const $widget = $(`#${widgetName}`);

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: isDesktopScreen ? [] : ['all'],
    showDescription: true,
    moreButton: true,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    maxItemsVisible: 4,
    itemsPerPanel: 1,
    buyNowButton: false,
    cardWidgetLoaded: function (data) {
      const widgetData = data.items;

      if (widgetData.length <= 0) {
        $('body').addClass(`${$widget}-no-data`);
        $(`.${wrapContainerClass}`).remove();
        return;
      } else {
        createCustomCards(widgetData);
      }
    },
  });

  function createCustomCards(widgetData) {
    $widget.find('.image-container').append('<div class="overlay"></div>');
    $widget.find('.card-content').remove();

    $widget.find('.card-widget-item').each(function (x) {
      const { Title, Description, URL } = widgetData[x];
      const $cardItem = $(this);

      $cardItem.append(`
          <div class="card-content">
            <div class="widget-title-wrapper">
              <span class="widget-title">
                ${Title}</span>
              </div>
            <div class="hover-content">
              ${Description ? `<p class="widget-description">${Description}</p>` : ''}
              ${URL ? `<a href="${URL}" class="button">More</a>` : ''}
            </div>
          </div>`);

      $cardItem.removeAttr('target');

      if (!URL && !Description) {
        $cardItem.addClass('empty-card').removeAttr('href');
      } else if (!URL && Description) {
        $cardItem.addClass('just-desc').removeAttr('href');
      } else if (URL && !Description) {
        $cardItem.addClass('only-url');
      }
    });
  }
}
